import React from 'react';
import { useNavigate } from 'react-router-dom';

import { requestUrl } from 'config';
import { useReactQuery } from 'hooks/useReactQuery';
import { ReactComponent as Medium } from 'assets/images/social/medium.svg';
import { ReactComponent as Facebook } from 'assets/images/social/facebook.svg';
import { ReactComponent as Instagram } from 'assets/images/social/instagram.svg';
import { ReactComponent as Twitter } from 'assets/images/social/twitter.svg';
// import { ReactComponent as Logo } from 'assets/images/logo/cojamnft_new_logo.svg';
import newLogo from 'assets/images/logo/unilapse_new_logo.svg';

const Footer = () => {
  const { getGlobalState } = requestUrl;
  const { data, isSuccess } = useReactQuery('globalState', getGlobalState, { staleTime: 999999, cachTime: 999999 });
  const global_url_bottom_ad = data && data?.global_url_ads[1].image;
  const navigate = useNavigate();

  return (
    <footer className="background-white top-152">
      {isSuccess && (
        <div
          className="nav-banner centered white poppins font-40"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${global_url_bottom_ad})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      )}
      <div className="footer-wrapper responsive-background-width margin-center">
        <div className="footer row justify-between relative">
          <div className="logo centered inline-block">
            {/* <Logo onClick={() => navigate('/')} height={32} className="link" /> */}
            <img src={newLogo} alt="new_logo" onClick={() => navigate('/')} height={32} className="link" />
          </div>
          <div className="content row grow align-center justify-between left-40 font-weight-300">
            <div className="menus justify-between">
              <div>
                <li className="menu-item inline-block">
                  <a href="https://unilapse.gitbook.io/unilapse/terms-of-service" target="_blank" rel="noreferrer noopener" className="name neutrals-2 neutrals-1-hover link font-14">
                    Terms of Service
                  </a>
                </li>
                {/* <li className="menu-item inline-block">
                  <a href="https://cojam.gitbook.io/cojam-nft/privacy" target="_blank" rel="noreferrer noopener" className="name neutrals-2 neutrals-1-hover link font-14">
                    Privacy
                  </a>
                </li> */}
              </div>
              <li className="menu-item inline-block guideline neutrals-2 font-weight-600 neutrals-1-hover link">
                <a href="https://unilapse.gitbook.io/unilapse/how-to-use" target="_blank" rel="noreferrer noopener" className="neutrals-2 link font-14">
                  How to use
                </a>
              </li>
            </div>
            {/* <ul className="icon-group">
              <li className="icon inline-block">
                <a href="https://www.instagram.com/cojam_official/" target="_blank" rel="noreferrer noopener" className="link">
                  <Instagram width={24} height={24} />
                </a>
              </li>
              <li className="icon inline-block">
                <a href="https://medium.com/cojam-official" target="_blank" rel="noreferrer noopener" className="link">
                  <Medium width={24} height={24} />
                </a>
              </li>
              <li className="icon inline-block">
                <a href="https://twitter.com/officialcojam" target="_blank" rel="noreferrer noopener" className="link">
                  <Twitter width={24} height={24} />
                </a>
              </li>
              <li className="icon inline-block">
                <a href="https://www.facebook.com/cojam.limited/" target="_blank" rel="noreferrer noopener" className="link">
                  <Facebook width={24} height={24} />
                </a>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
